import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { TaskSchema } from '../../entities/task';
/**
 * Complete Task Request Schema
 * POST /api/v2/task/:id/complete
 * No request body required
 */ export const CompleteTaskRequestSchema = z.void();
export const CompleteTaskResponseSchema = TaskSchema;
export const CompleteTaskErrorSchema = BaseErrorSchema;

//# sourceMappingURL=complete-task.schema.js.map